<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { locationMixin } from '@/mixins/location'
import { setLocalStorage } from '@/utils'

export default {
  name: 'App',
  mixins: [locationMixin],
  components: {
   
  },
  created () {
    // this.getLocation(city => {
    //   setLocalStorage(this.$store.state.location, city)
    // })
  }
}
</script>

<style lang='less'>
  @import "~@/assets/iconfont.less";
  @import "~@/assets/app.less";
</style>




// WEBPACK FOOTER //
// src/App.vue